"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelMeetingSchema = void 0;
exports.parsePanelMeeting = parsePanelMeeting;
const zod_1 = require("zod");
const panel_account_1 = require("./panel-account");
const panel_language_1 = require("./panel-language");
const panel_subject_1 = require("./panel-subject");
const panel_difficulty_level_1 = require("./panel-difficulty-level");
const hash_1 = require("./hash");
const image_file_1 = require("./image-file");
const user_service_category_1 = require("./user-service-category");
const content_stats_1 = require("./content-stats");
// Схема для PanelMeetingType (partial, для использования в API)
exports.PanelMeetingSchema = zod_1.z.object({
  id: zod_1.z.string(),
  author_id: zod_1.z.string().uuid().optional(),
  author: panel_account_1.PanelAccountSchema.optional(),
  type: zod_1.z.number(),
  category_id: zod_1.z.number().optional(),
  category: user_service_category_1.userServiceCategorySchema.optional(),
  slug: zod_1.z.string(),
  title: zod_1.z.string(),
  tokbox_session: zod_1.z.string().optional(),
  cover_id: zod_1.z.string(),
  cover: (0, hash_1.hashSchema)(image_file_1.imageFileSchema).optional(),
  description: zod_1.z.string(),
  language_id: zod_1.z.number().optional(),
  language: panel_language_1.PanelLanguageSchema.optional(),
  subject_id: zod_1.z.number(),
  subject: panel_subject_1.PanelSubjectSchema.optional(),
  level_id: zod_1.z.number().optional(),
  level: panel_difficulty_level_1.PanelDifficultyLevelSchema.optional(),
  level_other_name: zod_1.z.string().optional(),
  begin: zod_1.z.number().optional(),
  begin_at: zod_1.z.string().or(zod_1.z.date()),
  end_at: zod_1.z.string().or(zod_1.z.date()),
  duration: zod_1.z.number().optional(),
  classroom_id: zod_1.z.string().optional(),
  engine: zod_1.z.number().optional(),
  access: zod_1.z.number().optional(),
  charging: zod_1.z.number().optional(),
  options: zod_1.z.any().optional(),
  participants_limit: zod_1.z.number().optional(),
  participants_count: zod_1.z.number().optional(),
  reservations_count: zod_1.z.number().optional(),
  keywords: zod_1.z.any().optional(),
  status: zod_1.z.number().optional(),
  audio_video_state: zod_1.z.boolean().optional(),
  billing_status: zod_1.z.number().optional(),
  session_id: zod_1.z.string().optional(),
  school_id: zod_1.z.string().optional(),
  price_tier: zod_1.z.number().optional(),
  stats: content_stats_1.contentStatsSchema.optional(),
  billing_operations: zod_1.z.array(zod_1.z.any()).optional(),
  published_at: zod_1.z.string().or(zod_1.z.date()),
  archived_at: zod_1.z.string().or(zod_1.z.date()),
  started_at: zod_1.z.string().or(zod_1.z.date()),
  finished_at: zod_1.z.string().or(zod_1.z.date()),
  created_at: zod_1.z.string().or(zod_1.z.date()),
  updated_at: zod_1.z.string().or(zod_1.z.date()),
  deleted_at: zod_1.z.string().or(zod_1.z.date())
});
function parsePanelMeeting(values) {
  return exports.PanelMeetingSchema.parse(values);
}
